import api from './api';
import { Location, TravelStatus, TravelResult, StealCarResult, SellCarResult, UpgradeGarageResult, GarageInfo } from '../types';
import { gameService } from './gameService';

export const travelService = {
  getLocations: async (): Promise<{ success: boolean; locations: Location[] }> => {
    const response = await api.get('/travel/locations');
    return response.data;
  },

  getTravelStatus: async (): Promise<TravelStatus> => {
    const response = await api.get('/travel/status');
    return response.data;
  },

  stealCar: async (gtaType: string): Promise<StealCarResult> => {
    const response = await api.post('/travel/steal-car', { gtaType });
    // Clear user stats cache after GTA to ensure fresh data
    gameService.clearCache('user-stats');
    console.log('🧹 Cleared user-stats cache after GTA');
    return response.data;
  },

  travelToLocation: async (destination: string): Promise<TravelResult> => {
    const response = await api.post('/travel/travel', { destination });
    return response.data;
  },

  sellCar: async (carIndex?: number): Promise<SellCarResult> => {
    const response = await api.post('/travel/sell-car', { carIndex });
    return response.data;
  },

  equipCar: async (carIndex: number): Promise<{ success: boolean; message: string; carName?: string; carHealth?: number; carInstanceId?: string; updatedUser?: { carId: number | null; carHealth: number; equippedCarInstanceId: string | null } }> => {
    const response = await api.post('/travel/equip-car', { carIndex });
    return response.data;
  },

  unequipCar: async (): Promise<{ success: boolean; message: string; carName?: string; updatedUser?: { carId: number | null; carHealth: number; equippedCarInstanceId: string | null } }> => {
    const response = await api.post('/travel/unequip-car');
    return response.data;
  },

  upgradeGarage: async (garageId: number): Promise<UpgradeGarageResult> => {
    const response = await api.post('/travel/upgrade-garage', { garageId });
    return response.data;
  },

  getGarageInfo: async (): Promise<GarageInfo> => {
    const response = await api.get('/travel/garage-info');
    return response.data;
  }
};
